import { jsxs as r, jsx as l } from "react/jsx-runtime";
const e = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m48.38 28.327-5.796 1.553 1.553 5.795 5.796-1.553-1.553-5.795Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M58 46.92V12H43.77L20.55 5.77l-.39 1.47-5.81-1.56-1.7 6.32H9.51C7.57 12 6 13.57 6 15.51V48c0 2.21 1.79 4 4 4h45.07L54 48H10V16h33.25l.05.01V16H54v32l4-1.08ZM15.76 12l.71-2.64 2.92.78 3.86 1.03 3.05.83H15.76Z"
        }
      )
    ]
  }
);
export {
  e as Wallet
};
